import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  users: [],
  isLoading: true,
  error: null,
  notification: null,
  userPropertyData: {},
});

const users = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.USER_MANAGEMENT_USER_PFOFILE_INIT:
      return initState();
    case DispatchConstants.USER_MANAGEMENT_GET_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: payload.users,
      };
    case DispatchConstants.USER_MANAGEMENT_GET_USERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    default:
      return state;
  }
};

export default users;
